import { AllHashFunctions, AllSchemas } from '@efdigital/ll-addon-data';
import { ApiErrorHandler } from '@efdigital/ll-xceed-v2/data/handlers/api-error-handler';
import { authHandler } from '@efdigital/ll-xceed-v2/data/handlers/auth-handler';
import { DebugHandler } from '@efdigital/ll-xceed-v2/data/handlers/debug-handler';
import { TypeNormalizerHandler } from '@efdigital/ll-xceed-v2/data/handlers/type-normalizer-handler';
import { CoachingSharedResourceSchema } from '@efdigital/ll-xceed-v2/data/schemas/coaching-shared-resource';
import type { HashFn } from '@warp-drive/core/types/schema/concepts';
import type {
  ObjectSchema,
  ResourceSchema,
} from '@warp-drive/core/types/schema/fields';
import { JSONAPICache } from '@warp-drive/json-api';
import { useLegacyStore } from '@warp-drive/legacy';

const store = useLegacyStore({
  linksMode: false,
  legacyRequests: true,
  modelFragments: true,
  cache: JSONAPICache,
  schemas: [
    ...(AllSchemas as (ResourceSchema | ObjectSchema)[]),
    CoachingSharedResourceSchema,
  ],
  // ApiErrorHandler is first so it is outermost: handlers run in array order
  // and each one's `next()` wraps the rest, so only from here does a rejection
  // from TypeNormalizerHandler, DebugHandler, authHandler or the fetch itself
  // pass through one place on its way back to the app.
  handlers: [
    new ApiErrorHandler(),
    new TypeNormalizerHandler(),
    new DebugHandler(),
    authHandler,
  ],
  hashFns: [...(AllHashFunctions as HashFn[])],
});

export default store;
